import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';

import { appConstantsFactory, AppModule } from './app/app.module';
import { LicenseManager } from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(
  'CompanyName=Tesla, Inc.,LicensedGroup=Multi,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=12,LicensedProductionInstancesCount=20,AssetReference=AG-028578,SupportServicesEnd=6_July_2023_[v2]_MTY4ODU5ODAwMDAwMA==5e738cd0413465a0a84b92ee21c1cace'
);

const appConstants = appConstantsFactory();

if (appConstants.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
